import React from 'react';

// components
import { FormGroup, Input } from "reactstrap";
import Select from 'react-select'
import { useEffect } from 'react';

export default function InputResposta({ id, typeInput, label, listaOpcoes, handleChangeValor, obrigatorio, valor = null  }) {

    const [opcao, set_opcao] = React.useState(valor);
    const handleChangeOpcao = (value) => {
        set_opcao(value);
        handleChangeValor(id, value);
    }
    
    useEffect(() => {
        set_opcao(valor);
    }, [valor]);

    return (
        <>
            {typeInput == "Texto" &&
                <FormGroup>
                    <label className="form-control-label">{label}{obrigatorio && <span className="text-danger"> *</span>}</label>
                    <Input className="form-control"
                        autocomplete="off"
                        type="text"
                        name="texto"
                        maxLength="150"
                        value={opcao}
                        onChange={(e) => handleChangeValor(id, e.target.value)}
                    />
                </FormGroup>
            }
            {typeInput == "Número" &&

                <FormGroup>
                    <label className="form-control-label">{label}{obrigatorio && <span className="text-danger"> *</span>}</label>
                    <Input className="form-control"
                        autocomplete="off"
                        type="number"
                        name="numero"
                        value={Number(opcao)}
                        onChange={(e) => handleChangeValor(id, e.target.value)}
                    />
                </FormGroup>
            }
            {typeInput == "Data" &&
                <FormGroup>
                    <label className="form-control-label">{label}{obrigatorio && <span className="text-danger"> *</span>}</label>
                    <Input className="form-control"
                        autocomplete="off"
                        type="date"
                        name="data"
                        value={opcao}
                        onChange={(e) => handleChangeValor(id, e.target.value)}
                    />
                </FormGroup>
            }
            {typeInput == "Lista" &&
                <FormGroup>
                    <label className="form-control-label">{label}{obrigatorio && <span className="text-danger"> *</span>}</label>
                    <Select
                        name="lista"
                        options={listaOpcoes}
                        getOptionLabel={o => o}
                        getOptionValue={o => o}
                        value={listaOpcoes.filter(f => f == opcao)}
                        onChange={(o) => handleChangeOpcao(o)}
                        classNamePrefix="select"
                        placeholder="Selecione"
                    />
                </FormGroup>
            }
        </>
    );
}

